

const layoutControls =
    [
    //{ factoryKey: 'control_hello_world', name: 'Hello World', icon: 'pf-text', defaultGroup: 'layout', style: '', textStyle: '' },
    { factoryKey: 'control_text', name: 'Text', icon: 'pf-text', defaultGroup: 'layout', style: '', textStyle: '' },
    { factoryKey: 'control_small_text', name: 'Small Text', icon: 'pf-small-text', defaultGroup: 'layout' },
    { factoryKey: 'control_large_heading', name: 'Large Heading', icon: 'pf-large-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_medium_heading', name: 'Medium Heading', icon: 'pf-medium-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_small_heading', name: 'Small Heading', icon: 'pf-small-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_picture', name: 'Picture', icon: 'pf-picture', defaultGroup: 'containers' },
    { factoryKey: 'control_button', name: 'Button', icon: 'pf-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_submit_button', name: 'Submit Button', icon: 'pf-submit-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_page_button', name: 'Page Button', icon: 'pf-show-page-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_group', name: 'Group', icon: 'pf-group', defaultGroup: 'containers' },
    { factoryKey: 'control_text_input', name: 'Text Input', icon: 'pf-text-input', defaultGroup: 'input', style: 'font-size: 5rem; margin-top: -5px;', textStyle: ''  },
    { factoryKey: 'control_multiple_text_input', name: 'Multiline Text Input', icon: 'pf-multi-line-text-input', defaultGroup: 'input', style: 'font-size: 4rem; margin-top: 1px;', textStyle: '' },
    { factoryKey: 'control_numeric_input', name: 'Numeric Input', icon: 'pf-numeric-input', defaultGroup: 'input', style: 'font-size: 5rem; margin-top: -5px;', textStyle: ''  },
    { factoryKey: 'control_date_input', name: 'Date Input', icon: 'pf-date-input', defaultGroup: 'input', style: 'font-size: 5.3rem; margin-top: -8px;', textStyle: ''  },
    { factoryKey: 'control_time_input', name: 'Time Input', icon: 'pf-time-input', defaultGroup: 'input', style: 'font-size: 5rem; margin-top: -5px;', textStyle: ''  },
    { factoryKey: 'control_date_calendar', name: 'Date Calendar', icon: 'pf-calendar', defaultGroup: 'input' },
    { factoryKey: 'control_checkbox_group', name: 'Checkbox Group', icon: 'pf-checkbox-group', defaultGroup: 'input' },
    { factoryKey: 'control_checkbox', name: 'Checkbox', icon: 'pf-checkbox', defaultGroup: 'input', style: 'font-size: 2.2rem;' },
    { factoryKey: 'control_radio_button_group', name: 'Radio Button Group', icon: 'pf-radio-button-group', defaultGroup: 'input' },
    { factoryKey: 'control_radio_button', name: 'Radio Button', icon: 'pf-radio-button', defaultGroup: 'input', style: 'font-size: 2.2rem;' },
    { factoryKey: 'control_drop_down', name: 'Drop-Down', icon: 'pf-dropdown', defaultGroup: 'input' },
    { factoryKey: 'control_list', name: 'List', icon: 'pf-list', defaultGroup: 'containers' },
    { factoryKey: 'control_bullet_text', name: 'Bullet Text', icon: 'pf-bullet-text', defaultGroup: 'layout' },
    { factoryKey: 'control_vertical_separator', name: 'Vertical Separator', icon: 'pf-vertical-separator', defaultGroup: 'layout' },
    { factoryKey: 'control_horizontal_separator', name: 'Horizontal Separator', icon: 'pf-horizontal-separator', defaultGroup: 'layout'},
    //PF-3980. This shall be reactivated later or in another release.
    //{ factoryKey: 'control_sound', name: 'Sound', icon: 'pf-sound', defaultGroup: 'containers' },
    //PF-3980. This shall be reactivated later or in another release.
    // PF-4964 disable because is no longer usable
    // { factoryKey: 'control_movie', name: 'Movie', icon: 'pf-movie', defaultGroup: 'containers' },
    { factoryKey: 'control_link', name: 'Link', icon: 'pf-link', defaultGroup: 'layout' },
    { factoryKey: 'control_progress_bar', name: 'Progress Bar', icon: 'pf-progress-bar', defaultGroup: 'containers', style: 'font-size: 4.2rem; margin-top: 0;', textStyle: ''  },

    { factoryKey: 'control_timer', name: 'Timer', icon: 'pf-timer', defaultGroup: 'containers' },
    { factoryKey: 'control_print_button', name: 'Print Button', icon: 'pf-print-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_captcha', name: 'Captcha', icon: 'pf-captcha', defaultGroup: 'containers', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: ''  },
    { factoryKey: 'control_mask_text_input', name: 'Mask Text Input', icon: 'pf-mask-text-input', defaultGroup: 'input', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: ''  },
    { factoryKey: 'control_numeric_stepper', name: 'Numeric Stepper', icon: 'pf-numeric-stepper', defaultGroup: 'input', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: ''  },
    { factoryKey: 'control_password_input', name: 'Password Input', icon: 'pf-password-text-input', defaultGroup: 'input', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: ''  },
    { factoryKey: 'control_file_attachment', name: 'File Attachment', icon: 'pf-file-attachment', defaultGroup: 'containers' },
    //PF-2934. This shall be reactivated later on in a next release.
    //{ factoryKey: 'control_image_input', name: 'Image Import', icon: 'pf-image-import', defaultGroup: 'containers' },
    { factoryKey: 'control_websignature', name: 'Web Signature', icon: 'pf-web-signature', defaultGroup: 'input' },
    { factoryKey: 'control_vertical_slider', name: 'Vertical Slider', icon: 'pf-vertical-slider', defaultGroup: 'input' },
    { factoryKey: 'control_horizontal_slider', name: 'Horizontal Slider', icon: 'pf-horizontal-slider', defaultGroup: 'input' },
    { factoryKey: 'control_table', name: 'Table', icon: 'pf-table', defaultGroup: 'input' },
    { factoryKey: 'control_ranking', name: 'Ranking', icon: 'pf-ranking', defaultGroup: 'input' },
    { factoryKey: 'control_play_form_button', name: 'Show App Button', icon: 'pf-show-app-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''},
    { factoryKey: 'control_play_report_button', name: 'Show Report Button', icon: 'pf-show-report-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: '' }
];

const layoutBehaviorControls =
    [
        { factoryKey: 'command_submit_data', name: 'Submit Data', icon: 'pf-submit-data', defaultGroup: 'form' },
        { factoryKey: 'command_print', name: 'Print', icon: 'pf-print', defaultGroup: 'form' },
        { factoryKey: 'command_show_message', name: 'Show Message', icon: 'pf-show-message', defaultGroup: 'form' },
        { factoryKey: 'command_close', name: 'Close', icon: 'pf-close', defaultGroup: 'form' },
        { factoryKey: 'command_show_page', name: 'Show Page', icon: 'pf-show-page', defaultGroup: 'form' },
        { factoryKey: 'command_show_url', name: 'Show URL', icon: 'pf-show-url', defaultGroup: 'form', style: 'font-size: 5rem; margin-top: -4px;'},
        { factoryKey: 'command_cancel_submission', name: 'Cancel Submission', icon: 'pf-cancel-submission', defaultGroup: 'form',  style: 'font-size: 5rem; margin-top: -4px;'},
        { factoryKey: 'command_simple_branch', name: 'Simple Branch', icon: 'pf-simple-branch', defaultGroup: 'general' },
        { factoryKey: 'command_multiple_branch', name: 'Multiple Branch', icon: 'pf-mulitple-branch', defaultGroup: 'general' },
        { factoryKey: 'command_comment', name: 'Comment', icon: 'pf-comment', defaultGroup: 'general' },
        { factoryKey: 'command_run', name: 'Run Behavior', icon: 'pf-run-behavior', defaultGroup: 'general' },
        { factoryKey: 'command_start', name: 'Start', icon: 'pf-start', defaultGroup: 'general' },
        { factoryKey: 'command_exit', name: 'Exit', icon: 'pf-exit', defaultGroup: 'general' },
        { factoryKey: 'command_connect', name: 'Connect', icon: 'pf-connect', defaultGroup: 'integration' },
        { factoryKey: 'command_connect_search', name: 'Connect and Search', icon: 'pf-connect-search', defaultGroup: 'integration' },
        { factoryKey: 'command_show_form', name: 'Show App', icon: 'pf-show-form', defaultGroup: 'integration' },
        //PF-3980. This shall be reactivated later or in another release.
        { factoryKey: 'command_get_field_from_other', name: 'Get Field From Other Instance', icon: 'pf-get-field-from-other-instance', defaultGroup: 'integration',  style: 'font-size: 3.2rem; margin-top: 1px;', textStyle: 'margin-top:-14px;' },
        //PF-3980. This shall be reactivated later or in another release.
        { factoryKey: 'command_set_field_in_other', name: 'Set Field in Other Instance', icon: 'pf-set-field-from-other-instance', defaultGroup: 'integration', style: 'font-size: 3.2rem; margin-top: 1px;', textStyle: 'margin-top:-14px;' },
        { factoryKey: 'command_call_javascript', name: 'Call JavaScript', icon: 'pf-call-javascript', defaultGroup: 'integration' },
        { factoryKey: 'command_show_report', name: 'Show Report', icon: 'pf-show-report', defaultGroup: 'integration' },
        { factoryKey: 'command_transaction', name: 'Transaction', icon: 'pf-transaction', defaultGroup: 'integration' },
        { factoryKey: 'command_check_obligatory', name: 'Check Mandatory', icon: 'pf-check-mandatory', defaultGroup: 'objects' },
        { factoryKey: 'command_set_field_value', name: 'Set Field', icon: 'pf-set-field', defaultGroup: 'objects', style: 'font-size: 3.2rem; margin-top: 1px;' },
        { factoryKey: 'command_set_properties', name: 'Set Property', icon: 'pf-set-property', defaultGroup: 'objects' },
        { factoryKey: 'command_set_selection_items', name: 'Set Selection Items', icon: 'pf-set-selection-items', defaultGroup: 'objects', style: 'font-size: 3.2rem; margin-top: 1px;'},
        { factoryKey: 'command_set_state', name: 'Set State', icon: 'pf-set-state', defaultGroup: 'objects' },
        { factoryKey: 'command_show', name: 'Show ', icon: 'pf-show', defaultGroup: 'objects' },
        { factoryKey: 'command_set_table_rows', name: 'Set Table Rows', icon: 'pf-set-table-rows', defaultGroup: 'objects' },
        { factoryKey: 'command_copy_field_values', name: 'Copy Fields', icon: 'pf-copy-fields', defaultGroup: 'objects', style: 'font-size: 3.2rem; margin-top: 1px;'},
        //PF-3980. This shall be reactivated later or in another release.
        { factoryKey: 'command_start_stop', name: 'Start/Stop', icon: 'pf-start-stop', defaultGroup: 'objects' },
        { factoryKey: 'command_notify', name: 'Notify', icon: 'pf-notify', defaultGroup: 'workflow' },
        { factoryKey: 'command_cancel_notification', name: 'Cancel Notify', icon: 'pf-cancel-notify', defaultGroup: 'workflow' },
        { factoryKey: 'command_set_next_stage', name: 'Set Next Stage', icon: 'pf-set-next-stage', defaultGroup: 'workflow' }
    ];


const LayoutReportControls = [
    { factoryKey: 'control_text', name: 'Text', icon: 'pf-text', defaultGroup: 'layout' },
    { factoryKey: 'control_small_text', name: 'Small Text', icon: 'pf-small-text', defaultGroup: 'layout' },
    { factoryKey: 'control_large_heading', name: 'Large Heading', icon: 'pf-large-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_medium_heading', name: 'Medium Heading', icon: 'pf-medium-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_small_heading', name: 'Small Heading', icon: 'pf-small-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_bullet_text', name: 'Bullet Text', icon: 'pf-bullet-text', defaultGroup: 'layout' },
    { factoryKey: 'control_vertical_separator', name: 'Vertical Separator', icon: 'pf-vertical-separator', defaultGroup: 'layout' },
    { factoryKey: 'control_horizontal_separator', name: 'Horizontal Separator', icon: 'pf-horizontal-separator', defaultGroup: 'layout', textStyle: 'line-height: 12px; margin-top:-12px;'},
    { factoryKey: 'control_link', name: 'Link', icon: 'pf-link', defaultGroup: 'layout' },
    { factoryKey: 'control_progress_bar', name: 'Progress Bar', icon: 'pf-progress-bar', defaultGroup: 'containers' , style: 'font-size: 4.2rem; margin-top: 0;', textStyle: ''},

    { factoryKey: 'control_timer', name: 'Timer', icon: 'pf-timer', defaultGroup: 'containers' },
    { factoryKey: 'control_captcha', name: 'Captcha', icon: 'pf-captcha', defaultGroup: 'containers', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: '' },
    { factoryKey: 'control_mask_text_input', name: 'Mask Text Input', icon: 'pf-mask-text-input', defaultGroup: 'input', style: 'font-size: 5rem; margin-top: -5px;', textStyle: '' },
    { factoryKey: 'control_vertical_slider', name: 'Vertical Slider', icon: 'pf-vertical-slider', defaultGroup: 'input' },
    { factoryKey: 'control_horizontal_slider', name: 'Horizontal Slider', icon: 'pf-horizontal-slider', defaultGroup: 'input' },
    { factoryKey: 'control_text_input', name: 'Text Input', icon: 'pf-text-input', defaultGroup: 'input',  style: 'font-size: 5rem; margin-top: -5px;', textStyle: '' },
    { factoryKey: 'control_multiple_text_input', name: 'Multiline Text Input', icon: 'pf-multi-line-text-input', defaultGroup: 'input', style: 'font-size: 4rem; margin-top: 1px;', textStyle: '' },
    { factoryKey: 'control_numeric_input', name: 'Numeric Input', icon: 'pf-numeric-input', defaultGroup: 'input',  style: 'font-size: 5rem; margin-top: -5px;', textStyle: '' },
    { factoryKey: 'control_date_input', name: 'Date Input', icon: 'pf-date-input', defaultGroup: 'input',  style: 'font-size: 5.3rem; margin-top: -8px;', textStyle: '' },
    { factoryKey: 'control_time_input', name: 'Time Input', icon: 'pf-time-input', defaultGroup: 'input', style: 'font-size: 5rem; margin-top: -5px;', textStyle: '' },
    { factoryKey: 'control_date_calendar', name: 'Date Calendar', icon: 'pf-calendar', defaultGroup: 'input' },
    { factoryKey: 'control_checkbox_group', name: 'Checkbox Group', icon: 'pf-checkbox-group', defaultGroup: 'input' },
    { factoryKey: 'control_checkbox', name: 'Checkbox', icon: 'pf-checkbox', defaultGroup: 'input', style: 'font-size: 2.2rem;'  },
    { factoryKey: 'control_radio_button_group', name: 'Radio Button Group', icon: 'pf-radio-button-group', defaultGroup: 'input' },
    { factoryKey: 'control_radio_button', name: 'Radio Button', icon: 'pf-radio-button', defaultGroup: 'input', style: 'font-size: 2.2rem;' },
    { factoryKey: 'control_drop_down', name: 'Drop-Down', icon: 'pf-dropdown', defaultGroup: 'input' },
    { factoryKey: 'control_list', name: 'List', icon: 'pf-list', defaultGroup: 'containers' },
    { factoryKey: 'control_numeric_stepper', name: 'Numeric Stepper', icon: 'pf-numeric-stepper', defaultGroup: 'input' ,  style: 'font-size: 3.8rem; margin-top: 0;', textStyle: ''},
    { factoryKey: 'control_password_input', name: 'Password Input', icon: 'pf-password-text-input', defaultGroup: 'input',  style: 'font-size: 5rem; margin-top: -5px;', textStyle: '' },
    { factoryKey: 'control_file_attachment', name: 'File Attachment', icon: 'pf-file-attachment', defaultGroup: 'containers' },
    //PF-2934. This shall be reactivated later on in a next release.
    //{ factoryKey: 'control_image_input', name: 'Image Import', icon: 'pf-image-import', defaultGroup: 'containers' },
    { factoryKey: 'control_websignature', name: 'Web Signature', icon: 'pf-web-signature', defaultGroup: 'input' },
    { factoryKey: 'control_table', name: 'Table', icon: 'pf-table', defaultGroup: 'input' },
    { factoryKey: 'control_ranking', name: 'Ranking', icon: 'pf-ranking', defaultGroup: 'input' },
    { factoryKey: 'control_picture', name: 'Picture', icon: 'pf-picture', defaultGroup: 'containers' },
    { factoryKey: 'control_group', name: 'Group', icon: 'pf-group', defaultGroup: 'containers' },
    //PF-3980. This shall be reactivated later or in another release.
    //{ factoryKey: 'control_sound', name: 'Sound', icon: 'pf-sound', defaultGroup: 'containers' },
    //PF-3980. This shall be reactivated later or in another release.
    // PF-4964 disable because is no longer usable
    // { factoryKey: 'control_movie', name: 'Movie', icon: 'pf-movie', defaultGroup: 'containers' },
    { factoryKey: 'control_button', name: 'Button', icon: 'pf-button', defaultGroup: 'buttons',style: 'font-size: 5rem; margin-top: -4px;', textStyle: '' },
    { factoryKey: 'control_page_button', name: 'Page Button', icon: 'pf-show-page-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_print_button', name: 'Print Button', icon: 'pf-print-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_play_form_button', name: 'Show App Button', icon: 'pf-show-app-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_play_report_button', name: 'Show Report Button', icon: 'pf-show-report-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },

    { factoryKey: 'control_bar_chart', name: 'Bar Chart', icon: 'pf-bar-chart', defaultGroup: 'reporting' },
    { factoryKey: 'control_clear_filter_button', name: 'Clear Filter Button', icon: 'pf-clear-filter-button', defaultGroup: 'buttons', style: 'font-size: 5rem; margin-top: -4px;', textStyle: ''  },
    { factoryKey: 'control_crosstab', name: 'Crosstab', icon: 'pf-crosstab', defaultGroup: 'reporting' },
    { factoryKey: 'control_data_grid', name: 'Data Grid', icon: 'pf-data-grid', defaultGroup: 'reporting' },
    { factoryKey: 'control_data_list', name: 'Data List', icon: 'pf-data-list', defaultGroup: 'reporting' },
    { factoryKey: 'control_filter_input', name: 'Filter Input', icon: 'pf-filter-input', defaultGroup: 'reporting', style: 'font-size: 4.5rem; margin-top: -5px;', textStyle: ''},
    { factoryKey: 'control_filter_selector', name: 'Filter Selector', icon: 'pf-filter-selector', defaultGroup: 'reporting', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: ''},
    { factoryKey: 'control_gauge_chart', name: 'Gauge', icon: 'pf-gauge', defaultGroup: 'reporting' },
    { factoryKey: 'control_line_chart', name: 'Line Chart', icon: 'pf-line-chart', defaultGroup: 'reporting' },
    { factoryKey: 'control_pie_chart', name: 'Pie Chart', icon: 'pf-pie-chart', defaultGroup: 'reporting' },
    { factoryKey: 'control_value', name: 'Value', icon: 'pf-value', defaultGroup: 'reporting' }


];

const reportBehaviorControls =
    [
        { factoryKey: 'command_print', name: 'Print', icon: 'pf-print', defaultGroup: 'all' },
        { factoryKey: 'command_show_message', name: 'Show Message', icon: 'pf-show-message', defaultGroup: 'report' },
        { factoryKey: 'command_close', name: 'Close', icon: 'pf-close', defaultGroup: 'report' },
        { factoryKey: 'command_show_page', name: 'Show Page', icon: 'pf-show-page', defaultGroup: 'report' },
        { factoryKey: 'command_show_url', name: 'Show URL', icon: 'pf-show-url', defaultGroup: 'report', style: 'font-size: 3.2rem; margin-top: 1px;'},
        { factoryKey: 'command_simple_branch', name: 'Simple Branch', icon: 'pf-simple-branch', defaultGroup: 'general' },
        { factoryKey: 'command_multiple_branch', name: 'Multiple Branch', icon: 'pf-mulitple-branch', defaultGroup: 'general' },
        { factoryKey: 'command_comment', name: 'Comment', icon: 'pf-comment', defaultGroup: 'general' },
        { factoryKey: 'command_run', name: 'Run Behavior', icon: 'pf-run-behavior', defaultGroup: 'general' },
        { factoryKey: 'command_start', name: 'Start', icon: 'pf-start', defaultGroup: 'general' },
        { factoryKey: 'command_exit', name: 'Exit', icon: 'pf-exit', defaultGroup: 'general' },
        { factoryKey: 'command_connect', name: 'Connect', icon: 'pf-connect', defaultGroup: 'integration' },
        { factoryKey: 'command_connect_search', name: 'Connect and Search', icon: 'pf-connect-search', defaultGroup: 'integration' },
        { factoryKey: 'command_show_form', name: 'Show App', icon: 'pf-show-form', defaultGroup: 'integration' },
        //PF-3980. This shall be reactivated later or in another release.
        { factoryKey: 'command_get_field_from_other', name: 'Get Field From Other Instance', icon: 'pf-get-field-from-other-instance', defaultGroup: 'integration',  style: 'font-size: 3.2rem; margin-top: 1px;'},
        //PF-3980. This shall be reactivated later or in another release.
        { factoryKey: 'command_set_field_in_other', name: 'Set Field in Other Instance', icon: 'pf-set-field-from-other-instance', defaultGroup: 'integration', style: 'font-size: 3.2rem; margin-top: 1px;' },
        { factoryKey: 'command_call_javascript', name: 'Call JavaScript', icon: 'pf-call-javascript', defaultGroup: 'integration' },
        { factoryKey: 'command_show_report', name: 'Show Report', icon: 'pf-show-report', defaultGroup: 'integration' },
        { factoryKey: 'command_transaction', name: 'Transaction', icon: 'pf-transaction', defaultGroup: 'integration' },
        { factoryKey: 'command_check_obligatory', name: 'Check Mandatory', icon: 'pf-check-mandatory', defaultGroup: 'objects' },
        { factoryKey: 'command_set_field_value', name: 'Set Field', icon: 'pf-set-field', defaultGroup: 'objects',  style: 'font-size: 3.2rem; margin-top: 1px;' },
        { factoryKey: 'command_set_properties', name: 'Set Property', icon: 'pf-set-property', defaultGroup: 'objects' },
        { factoryKey: 'command_set_selection_items', name: 'Set Selection Items', icon: 'pf-set-selection-items', defaultGroup: 'objects', style: 'font-size: 3.2rem; margin-top: 1px;'},
        { factoryKey: 'command_set_state', name: 'Set State', icon: 'pf-set-state', defaultGroup: 'objects' },
        { factoryKey: 'command_show', name: 'Show ', icon: 'pf-show', defaultGroup: 'objects' },
        { factoryKey: 'command_set_table_rows', name: 'Set Table Rows', icon: 'pf-set-table-rows', defaultGroup: 'objects' },
        { factoryKey: 'command_copy_field_values', name: 'Copy Fields', icon: 'pf-copy-fields', defaultGroup: 'objects', style: 'font-size: 3.2rem; margin-top: 1px;' },
        //PF-3980. This shall be reactivated later or in another release.
        { factoryKey: 'command_start_stop', name: 'Start/Stop', icon: 'pf-start-stop', defaultGroup: 'objects' },
        { factoryKey: 'control_report_refresh', name: 'Refresh Report', icon: 'pf-refresh-report', defaultGroup: 'report' },
        { factoryKey: 'control_set_filter', name: 'Set Filter', icon: 'pf-set-filter', defaultGroup: 'report' },
        { factoryKey: 'control_clear_filter', name: 'Clear Filter', icon: 'pf-set-filter', defaultGroup: 'report' },
        { factoryKey: 'command_print', name: 'Print', icon: 'pf-print', defaultGroup: 'report' }
    ];




const layoutCommonGroupControlDefaults = [
    { factoryKey: 'control_button', name: 'Button', icon: 'pf-button', defaultGroup: 'buttons', style: 'font-size: 4.5rem; margin-top: -4px;', textStyle: 'margin-top: -10px;'  },
    { factoryKey: 'control_text_input', name: 'Text Input', icon: 'pf-text-input', defaultGroup: 'input', style: 'font-size: 3.8rem; margin-top: -4px;', textStyle: 'margin-top: -10px;'  },
    { factoryKey: 'control_drop_down', name: 'Drop-Down', icon: 'pf-dropdown', defaultGroup: 'input' },
    { factoryKey: 'control_date_input', name: 'Date Input', icon: 'pf-date-input', defaultGroup: 'input', style: 'font-size: 3.8rem; margin-top: 0;', textStyle: 'margin-top: -10px;'  },
    { factoryKey: 'control_medium_heading', name: 'Medium Heading', icon: 'pf-medium-heading', defaultGroup: 'layout' },
    { factoryKey: 'control_checkbox', name: 'Checkbox', icon: 'pf-checkbox', defaultGroup: 'input' },
    { factoryKey: 'control_radio_button_group', name: 'Radio Button Group', icon: 'pf-radio-button-group', defaultGroup: 'input' },
    { factoryKey: 'control_horizontal_separator', name: 'Horizontal Separator', icon: 'pf-horizontal-separator', defaultGroup: 'layout' },
    { factoryKey: 'control_multiple_text_input', name: 'Multiline Text Input', icon: 'pf-multi-line-text-input', defaultGroup: 'input', style: 'font-size: 3rem; margin-top: 7px;', textStyle: 'margin-top: -9px;' },
    { factoryKey: 'control_numeric_input', name: 'Numeric Input', icon: 'pf-numeric-input', defaultGroup: 'input', style: 'font-size: 3.8rem; margin-top: -4px;', textStyle: 'margin-top: -10px;'  },
    { factoryKey: 'control_table', name: 'Table', icon: 'pf-table', defaultGroup: 'input' },
    { factoryKey: 'control_file_attachment', name: 'File Attachment', icon: 'pf-file-attachment', defaultGroup: 'containers' }
];

const behaviorCommonGroupControlDefaults = [
    { factoryKey: 'command_notify', name: 'Notify', icon: 'pf-notify', defaultGroup: 'workflow' },
    { factoryKey: 'command_simple_branch', name: 'Simple Branch', icon: 'pf-simple-branch', defaultGroup: 'general' },
    { factoryKey: 'command_multiple_branch', name: 'Multiple Branch', icon: 'pf-mulitple-branch', defaultGroup: 'general' },
    { factoryKey: 'command_comment', name: 'Comment', icon: 'pf-comment', defaultGroup: 'general' },
    { factoryKey: 'command_submit_data', name: 'Submit Data', icon: 'pf-submit-data', defaultGroup: 'form' },
    { factoryKey: 'command_connect', name: 'Connect', icon: 'pf-connect', defaultGroup: 'integration' },
    { factoryKey: 'command_set_field_value', name: 'Set Field', icon: 'pf-set-field', defaultGroup: 'objects', style: 'font-size: 3.2rem; margin-top: 1px;' }

];
const reportCommonGroupControlDefaults = [
    { factoryKey: 'control_pie_chart', name: 'Pie Chart', icon: 'pf-pie-chart', defaultGroup: 'reporting' },
    { factoryKey: 'control_bar_chart', name: 'Bar Chart', icon: 'pf-bar-chart', defaultGroup: 'reporting' },
    { factoryKey: 'control_button', name: 'Button', icon: 'pf-button', defaultGroup: 'buttons' },
    { factoryKey: 'control_clear_filter_button', name: 'Clear Filter Button', icon: 'pf-clear-filter-button', defaultGroup: 'buttons' },
    { factoryKey: 'control_filter_input', name: 'Filter Input', icon: 'pf-filter-input', defaultGroup: 'reporting' },
    { factoryKey: 'control_text', name: 'Text', icon: 'pf-text', defaultGroup: 'layout' },
    { factoryKey: 'control_text_input', name: 'Text Input', icon: 'pf-text-input', defaultGroup: 'input' },
    { factoryKey: 'control_gauge_chart', name: 'Gauge', icon: 'pf-gauge', defaultGroup: 'reporting' },
    { factoryKey: 'control_horizontal_separator', name: 'Horizontal Separator', icon: 'pf-horizontal-separator', defaultGroup: 'layout' }
];

const reportBehaviorCommonGroupControlDefaults = [
    { factoryKey: 'command_simple_branch', name: 'Simple Branch', icon: 'pf-simple-branch', defaultGroup: 'general' },
    { factoryKey: 'command_multiple_branch', name: 'Multiple Branch', icon: 'pf-mulitple-branch', defaultGroup: 'general' },
    { factoryKey: 'control_set_filter', name: 'Set Filter', icon: 'pf-set-filter', defaultGroup: 'report' },
    { factoryKey: 'control_clear_filter', name: 'Clear Filter', icon: 'pf-set-filter', defaultGroup: 'report' },
    { factoryKey: 'control_report_refresh', name: 'Refresh Report', icon: 'pf-refresh-report', defaultGroup: 'report' }
];

class ToolboxItemMapService {
    constructor() {

        // Build immutable structure from raw object structure
        this._layoutMap = layoutControls;
        this._layoutBehaviorMap = layoutBehaviorControls;
        this._layoutReportMap = LayoutReportControls;
        this._reportBehaviorMap = reportBehaviorControls;
        this._layoutCommonGroupControlDefaultsMap = layoutCommonGroupControlDefaults;
        this._behaviorCommonGroupControlDefaultsMap = behaviorCommonGroupControlDefaults;
        this._reportCommonGroupControlDefaultsMap = reportCommonGroupControlDefaults;
        this._reportBehaviorCommonGroupControlDefaultsMap = reportBehaviorCommonGroupControlDefaults;

        //this._commonGroupList = Immutable.OrderedMap();
        this._commonGroupList = [];
        this._commonBehaviorGroupList = [];
        this._commonReportGroupList = [];
        this._commonReportBehaviorGroupList = [];

        //this.addCommonGroupItem({ factoryKey: 'control_text', name: 'Text', icon: 'pf-text', defaultGroup: 'layout' });
        //this.addCommonGroupItem({ factoryKey: 'control_small_text', name: 'Small Text', icon: 'pf-small-text', defaultGroup: 'layout' });
    }

    // Layout Items
    getLayoutItemsByGroup(defaultGroup ) {
        var list = [];

        if(defaultGroup === 'all') { list = this._layoutMap; }
        else if(defaultGroup === 'common') {
            list = this._commonGroupList;
        }
        else {
            _.forEach(this._layoutMap, function (v) {
                if (v.defaultGroup === defaultGroup) {
                    list.push(v);
                }
            });
        }
        return list;
    }

    getBehaviorItemsByGroup(defaultGroup ) {
        var list = [];

        if(defaultGroup === 'all') { list = this._layoutBehaviorMap; }
        else if(defaultGroup === 'common') {
            list = this._commonBehaviorGroupList;
        }
        else {
            _.forEach(this._layoutBehaviorMap, function (v) {
                if (v.defaultGroup === defaultGroup) {
                    list.push(v);
                }
            });
        }
        return list;
    }

    addCommonGroupItem(object) {
        //this._commonGroupList = this._commonGroupList.set(object.factoryKey, object);

        this._commonGroupList.push(object);
    }

    removeCommonGroupItem(object) {

    }

    // This replaces the item array with one passed in.
    updateCommonGroupItems(items) {
        this._commonGroupList = items;
    }

    updateBehaviorCommonGroupItems(items) {
        this._commonBehaviorGroupList = items;
    }

    //Layout
    getAvailableLayoutItems() {
        var list =[];
        var self = this;
        var alreadyInList = false;

        _.forEach(this._layoutMap, function (v) {
            alreadyInList = false;
            _.find(self._commonGroupList, function (c) {
               if (v.factoryKey === c.factoryKey) {
                   alreadyInList = true;
                   return c;
               }
            });


            if (!alreadyInList) { list.push(v); }
        });

        return list;
    }
    getLayoutCommonGroupDefaults() {
        return this._layoutCommonGroupControlDefaultsMap;
    }
    // Behavior
    getAvailableBehaviorItems() {
        var list =[];
        var self = this;
        var alreadyInList = false;

        _.forEach(this._layoutBehaviorMap, function (v) {
            alreadyInList = false;
            _.find(self._commonBehaviorGroupList, function (c) {
                if (v.factoryKey === c.factoryKey) {
                    alreadyInList = true;
                    return c;
                }
            });


            if (!alreadyInList) { list.push(v); }
        });

        return list;
    }
    getBehaviorCommonGroupDefaults() {
        return this._behaviorCommonGroupControlDefaultsMap;
    }


    // Report Items
    getReportItemsByGroup(defaultGroup ) {
        var list = [];

        if(defaultGroup === 'all') { list = this._layoutReportMap; }
        else if(defaultGroup === 'common') {
            list = this._commonReportGroupList;
        }
        else {
            _.forEach(this._layoutReportMap, function (v) {
                if (v.defaultGroup === defaultGroup) {
                    list.push(v);
                }
            });
        }
        return list;
    }
    getReportBehaviorItemsByGroup(defaultGroup ) {
        var list = [];

        if(defaultGroup === 'all') { list = this._reportBehaviorMap; }
        else if(defaultGroup === 'common') {
            list = this._commonReportBehaviorGroupList;
        }
        else {
            _.forEach(this._reportBehaviorMap, function (v) {
                if (v.defaultGroup === defaultGroup) {
                    list.push(v);
                }
            });
        }
        return list;
    }

    updateReportCommonGroupItems(items) {
        this._commonReportGroupList = items;
    }
    updateReportBehaviorCommonGroupItems(items) {
        this._commonReportBehaviorGroupList = items;
    }

    getAvailableReportItems() {
        var list =[];
        var self = this;
        var alreadyInList = false;

        _.forEach(this._layoutReportMap, function (v) {
            alreadyInList = false;
            _.find(self._commonReportGroupList, function (c) {
                if (v.factoryKey === c.factoryKey) {
                    alreadyInList = true;
                    return c;
                }
            });


            if (!alreadyInList) { list.push(v); }
        });

        return list;
    }
    getReportCommonGroupDefaults() {
        return this._reportCommonGroupControlDefaultsMap;
    }

    getAvailableReportBehaviorItems() {
        var list =[];
        var self = this;
        var alreadyInList = false;

        _.forEach(this._reportBehaviorMap, function (v) {
            alreadyInList = false;
            _.find(self._commonReportBehaviorGroupList, function (c) {
                if (v.factoryKey === c.factoryKey) {
                    alreadyInList = true;
                    return c;
                }
            });


            if (!alreadyInList) { list.push(v); }
        });

        return list;
    }

    getReportBehaviorCommonGroupDefaults() {
        return this._reportBehaviorCommonGroupControlDefaultsMap;
    }

    getMobileControls() {
        return [];
    }

}

const toolboxItemMapService = new ToolboxItemMapService();
export default toolboxItemMapService;
